import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import 'moment/locale/uk';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { onValidate } from './InputFormik';
import { useField } from 'formik';

interface IField {
  label?: string;
  required?: boolean;
  disabled?: boolean;
  name: string;
  children?: JSX.Element;
  style?: React.CSSProperties | undefined;
  className?: string;
}

export const BasicDatePickerFormik: React.FC<IField> = ({ disabled, label, name, required, style, className }) => {
  const [field, meta, { setValue }] = useField({
    name,
    validate: (value: string) => onValidate(value, { required }),
  });

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DateTimePicker
        mask="__.__.____"
        inputFormat="DD.MM.YYYY"
        label={label}
        views={['year', 'month', 'day']}
        className={className}
        {...field}
        onChange={(date) => setValue(date)}
        renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
          <TextField
            fullWidth
            style={style}
            disabled={disabled}
            label={label || ''}
            size="small"
            variant="outlined"
            {...params}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
          />
        )}
      />
    </LocalizationProvider>
  );
};
